import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=0c8220f8&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=0c8220f8&prod&scoped=true&lang=css"
import style1 from "./ContactForm.vue?vue&type=style&index=1&id=0c8220f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8220f8",
  null
  
)

export default component.exports